document.addEventListener('DOMContentLoaded', function () {
  const geographyLink = document.querySelector('.education-path__heading-link');
  const geography = document.getElementById('geography');

  if (!geographyLink || !geography) {
    return;
  }

  const highlightClass = 'schools__geography--highlighted';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const scrollKeys = new Set([
    'ArrowDown',
    'ArrowUp',
    'End',
    'Home',
    'PageDown',
    'PageUp',
    ' '
  ]);
  let highlightCleanupTimer = null;
  let scrollFrame = null;

  const cancelScroll = function () {
    if (scrollFrame !== null) {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = null;
    }
  };

  const shouldReduceMotion = function () {
    return reducedMotion.matches
      || document.body.dataset.accessibility === 'true'
      || document.body.dataset.noImages === 'true';
  };

  const getTargetScrollTop = function () {
    const header = document.querySelector('.header');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const targetDocumentTop = geography.getBoundingClientRect().top + window.scrollY;
    const maximumScrollTop = document.documentElement.scrollHeight - window.innerHeight;

    return Math.min(
      Math.max(0, targetDocumentTop - headerHeight - 40),
      maximumScrollTop
    );
  };

  const scrollToGeography = function () {
    const startScrollTop = window.scrollY;
    const targetScrollTop = getTargetScrollTop();
    const scrollDistance = targetScrollTop - startScrollTop;

    cancelScroll();

    if (shouldReduceMotion() || Math.abs(scrollDistance) < 1) {
      window.scrollTo({
        top: targetScrollTop,
        behavior: 'auto'
      });
      return;
    }

    const duration = 820;
    let startTime = null;

    const animateScroll = function (timestamp) {
      if (startTime === null) {
        startTime = timestamp;
      }

      const progress = Math.min((timestamp - startTime) / duration, 1);
      const easedProgress = progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;
      const currentTargetScrollTop = getTargetScrollTop();
      const currentScrollDistance = currentTargetScrollTop - startScrollTop;

      window.scrollTo({
        top: startScrollTop + currentScrollDistance * easedProgress,
        behavior: 'auto'
      });

      if (progress < 1) {
        scrollFrame = window.requestAnimationFrame(animateScroll);
      } else {
        scrollFrame = null;
      }
    };

    scrollFrame = window.requestAnimationFrame(animateScroll);
  };

  window.addEventListener('pointerdown', cancelScroll, {
    capture: true,
    passive: true
  });
  window.addEventListener('touchstart', cancelScroll, {
    capture: true,
    passive: true
  });
  window.addEventListener('wheel', cancelScroll, {
    capture: true,
    passive: true
  });
  window.addEventListener('keydown', function (event) {
    if (scrollKeys.has(event.key)) {
      cancelScroll();
    }
  }, true);

  geographyLink.addEventListener('click', function (event) {
    if (
      event.button !== 0
      || event.metaKey
      || event.ctrlKey
      || event.shiftKey
      || event.altKey
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (window.location.hash !== '#geography') {
      window.history.pushState(window.history.state, '', '#geography');
    }

    geography.classList.remove(highlightClass);
    void geography.offsetWidth;
    geography.classList.add(highlightClass);

    scrollToGeography();

    if (highlightCleanupTimer !== null) {
      window.clearTimeout(highlightCleanupTimer);
    }

    highlightCleanupTimer = window.setTimeout(function () {
      geography.classList.remove(highlightClass);
      highlightCleanupTimer = null;
    }, 1600);
  });
});
